import { site } from "../content";
import { Icon } from "./Icon";
import { Reveal, SectionHeading } from "./Reveal";

const spans = [
  "md:col-span-4",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-4",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
];

export default function Benefits() {
  return (
    <section id="beneficios" data-testid="benefits-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading
          chapter="03"
          eyebrow="Benefícios"
          title="Não é só uma toalha quente."
          subtitle="É uma rotina de atendimento mais organizada, eficiente e profissional."
          testId="benefits-heading"
        />

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-6">
          {site.benefits.map((b, i) => (
            <Reveal key={b.title} delay={(i % 3) * 0.08} className={spans[i]}>
              <div
                data-testid={`benefit-card-${i}`}
                className="group h-full rounded-2xl border border-white/10 bg-graphite/60 p-7 backdrop-blur-xl transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_16px_50px_rgba(212,175,55,0.08)]"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-gold/25 bg-gold/[0.07] text-gold">
                  <Icon name={b.icon} className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-display text-base font-extrabold uppercase tracking-wide text-bone">
                  {b.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-bone/55">{b.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
